var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.557 6.346 1.42 3.124 3.474.564c.539.102.735.768.343 1.127l-2.398 2.407.538 3.637c.098.563-.44.922-.88.666l-2.938-1.64-3.132 1.691c-.49.256-.979-.154-.881-.717l.587-3.38-2.496-2.613c-.391-.41-.147-1.076.343-1.127l3.28-.461 1.614-3.278a.631.631 0 0 1 1.126 0z"
  })));
};
export default SvgStar;